import axios from 'axios';
export const { source } = axios.CancelToken;
import env from 'env'
export default axios.create({
  baseURL: env.baseUrl,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
})

export const download = (data: Blob, name: string) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(data);

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}